import React from 'react';
import { useRecordContext } from 'react-admin';
import Box from '@mui/material/Box';

import ChipField, { getChipColors } from '../../common/fields/ChipField';


const PeppolStatusField = ({ source = 'peppol_status', size = 'small', ...props }) => {
	const record = useRecordContext();

	if (!record) {
		return null;
	}

	const status = record[source];
	const isValidated = record.peppol_validated;
	const hasErrors = record.peppol_validation_errors && record.peppol_validation_errors.length > 0;

	const statuses = {
		'TRANSPORT_ACK_RECEIVED': 'ACK Received',
		'INVOICE_SENT': 'Sent to PEPPOL',
		'NOT_PRESENT_IN_PEPPOL': 'Not on PEPPOL',
		'IN_PROGRESS': 'In Progress',
		'UNKNOWN': 'Unknown'
	};

	let sx;
	switch (status) {
		case 'TRANSPORT_ACK_RECEIVED':
			sx = getChipColors('green');
			break;
		case 'INVOICE_SENT':
			sx = getChipColors('blue');
			break;
		case 'NOT_PRESENT_IN_PEPPOL':
			sx = getChipColors('orange');
			break;
		case 'IN_PROGRESS':
			sx = getChipColors('default');
			break;
		case 'UNKNOWN':
		default:
			sx = getChipColors('red');
			break;
	}

	// Determine validation status chip
	let validationChip = null;
	if (isValidated) {
		if (hasErrors) {
			validationChip = (
				<ChipField
					source="validation_failed"
					record={{ validation_failed: 'Validation Failed' }}
					sx={getChipColors('red')}
					size={size}
				/>
			);
		} else {
			validationChip = (
				<ChipField
					source="validation_passed"
					record={{ validation_passed: 'Validated ✓' }}
					sx={getChipColors('green')}
					size={size}
				/>
			);
		}
	} else {
		validationChip = (
			<ChipField
				source="not_validated"
				record={{ not_validated: 'Not Validated' }}
				sx={getChipColors('default')}
				size={size}
			/>
		);
	}

	// Show both validation status and PEPPOL status
	return (
		<Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
			{validationChip}
			{status && (
				<ChipField source={status} record={statuses} sx={sx} size={size} {...props} />
			)}
		</Box>
	);
};

export default PeppolStatusField;
